import * as o2Api from "../api";

// 당일매출현황
export const getCurrentDay = async (params) => {
  try {
    const { data: result } = await o2Api.getCurrentDay(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  } catch (e) {
    console.error(e.message);
    return [];
  }
};

export const getDailySale = async (params) => {
  try {
    const { data: result } = await o2Api.getDailySales(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  } catch (e) {
    console.error(e.message);
    return [];
  }
};

export const getMonthlySale = async (params) => {
  try {
    const { data: result } = await o2Api.getMonthlySales(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  } catch (e) {
    console.error(e.message);
    return [];
  }
};

export const getDailyHourlySale = async (params) => {
  try {
    const { data: result } = await o2Api.getDailyHourlySales(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  } catch (e) {
    console.error(e.message);
    return [];
  }
};

export const getWebCloseReport = async (params) => {
  try {
    const { data: result } = await o2Api.getDailyHourlySales(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  }
  catch (e) {
    return [];
  }
}

export const getBcmpSaleReport = async (params) => {
  try {
    const { data: result } = await o2Api.getBcmpSaleReport(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  }
  catch (e) {
    return [];
  }
}

export const getDailyStoreSaleReport = async (params) => {
  try {
    const { data: result } = await o2Api.getDailyStoreSaleReport(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    } else {
      return [];
    }
  }
  catch (e) {
    return [];
  }
}
